import SchemaSectionRenderer from './SchemaSectionRenderer'

export default SchemaSectionRenderer
